import { useCallback } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorResponseMessage } from 'js/hooks/server';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';

import * as server from './server';
import * as helpers from './helpers';
import * as actions from '../../store/actions';
import { useDynamicReducerDispatch } from '../../store';
import { TGetTermsAndConditionsHistoryResponse } from '../../types';

export const useGetHistory = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const { showComponentError } = useComponentMethods();
    const getErrorResponseMessage = useGetErrorResponseMessage();

    return useCallback(async () => {
        dispatch(actions.toggleIsLoading(true));

        server.getTermsAndConditionsHistory().then((response: TGetTermsAndConditionsHistoryResponse) => {
            isMounted() && dispatch(actions.updateTermsAndConditionsHistory(helpers.parseResponse(response)));
        })
        .catch((error) => {
            isMounted() && showComponentError(getErrorResponseMessage(error));
        })
        .finally(() => {
            isMounted() && dispatch(actions.toggleIsLoading(false));
        });
    }, [dispatch, getErrorResponseMessage, showComponentError, isMounted]);
};
